import { create } from 'zustand';

import { SubsetFact } from '../../backend/src/types/types';

interface Store {
  popupFact: SubsetFact | null;
  setPopupFact: (fact: SubsetFact | null) => void;

  popupFactFromTranscription: { factId: string; caseId: string } | null;
  setPopupFactFromTranscription: (popup: { factId: string; caseId: string } | null) => void;

  // Reference drawer state
  referenceDrawer: {
    isOpen: boolean;
    factId: string | null;
    chunkId: string | null;
    docId: string | null;
    caseId: string | null;
  };
  openReferenceDrawer: (params: { factId?: string; chunkId?: string; docId?: string; caseId?: string }) => void;
  closeReferenceDrawer: () => void;

  // Inconsistency drawer state
  inconsistencyDrawer: {
    isOpen: boolean;
    inconsistencyIds: string[];
  };
  openInconsistencyDrawer: (params: { inconsistencyIds: string[] }) => void;
  closeInconsistencyDrawer: () => void;
}

export const useStore = create<Store>((set) => ({
  popupFact: null,
  setPopupFact: (fact: SubsetFact | null) => set({ popupFact: fact }),

  popupFactFromTranscription: null,
  setPopupFactFromTranscription: (popup: { factId: string; caseId: string } | null) =>
    set({ popupFactFromTranscription: popup }),

  // Reference drawer state
  referenceDrawer: {
    isOpen: false,
    factId: null,
    chunkId: null,
    docId: null,
    caseId: null,
  },
  openReferenceDrawer: ({ factId, chunkId, docId, caseId }) =>
    set({
      referenceDrawer: {
        isOpen: true,
        factId: factId || null,
        chunkId: chunkId || null,
        docId: docId || null,
        caseId: caseId || null,
      },
    }),
  closeReferenceDrawer: () => {
    // Set is open false first and then after a small delay set other values to null
    set((state) => ({
      referenceDrawer: {
        ...state.referenceDrawer,
        isOpen: false,
      },
    }));
    setTimeout(() => {
      set({
        referenceDrawer: {
          isOpen: false,
          factId: null,
          chunkId: null,
          docId: null,
          caseId: null,
        },
      });
    }, 200);
  },

  // Inconsistency drawer state
  inconsistencyDrawer: {
    isOpen: false,
    inconsistencyIds: [],
  },
  openInconsistencyDrawer: ({ inconsistencyIds }) => set({ inconsistencyDrawer: { isOpen: true, inconsistencyIds } }),
  closeInconsistencyDrawer: () => {
    set((state) => ({
      inconsistencyDrawer: {
        ...state.inconsistencyDrawer,
        isOpen: false,
      },
    }));
    setTimeout(() => {
      set({
        inconsistencyDrawer: {
          isOpen: false,
          inconsistencyIds: [],
        },
      });
    }, 200);
  },
}));
